<app-job-application-login-modal #jobApplicationLoginModal></app-job-application-login-modal>
<app-job-application-profile-modal #jobApplicationProfileModal></app-job-application-profile-modal>
<app-job-application-verified-modal #jobApplicationVerifiedModal></app-job-application-verified-modal>
<job-application-modal #jobApplicationModal (eventApplication)="eventApplicationParent($event)"></job-application-modal> 
